import { useMutation, useQuery } from 'react-query';
import { customerBusinessService } from 'src/services';

const removeDevices = async (payload) => {
    const response = await customerBusinessService.removeAllAuthenticatedDevices(payload);
};

export default function useRemoveAllDevices() {
    return useMutation((payload: any) => removeDevices(payload));
}
